import { Injectable } from '@angular/core';
import { FilterInfo, FilterType } from '../core-data-model/FilterInfo.model';
import {
    ODataQueryGeneratorService,
    KeyValue
} from '../core-services/ODataQueryGenerator.service';

@Injectable({ providedIn: 'root' })
export class UrlShortenerQueryGeneratorService extends ODataQueryGeneratorService {
    getSearchParameters(filterState: FilterInfo[]): KeyValue[] {
        const searchFilter = filterState.find(
            (filter: FilterInfo) => filter.type === FilterType.Search
        );
        if (searchFilter) {
            return [
                {
                    key: '$filter',
                    value:
                        "(substringof('" +
                        searchFilter.parameters.term +
                        "', linkName) eq true) or" +
                        "(endswith(shortenedUrl, '" +
                        searchFilter.parameters.term +
                        "') eq true)"
                }
            ];
        }

        return [];
    }

    protected filterFilterList(filters: FilterInfo[]): FilterInfo[] {
        return filters.filter((filter) => filter.type !== FilterType.Search);
    }
}
